import React, { useState, useEffect, useContext, useMemo } from "react";
import TableHead from "../../common/thead";
import axios from "axios";
import { useParams } from "react-router-dom";
import TableBody from "../../common/tbody";
import "./index.scss";
import Breadcrumbs from "../../common/breadcumb";
import NoDataPage from "../../common/nodata";
import Loading from "../../common/loading";
import Errors from "../../common/error";
import { LangContext } from "../../context/LangContext";
import { TabTitle } from "../../common/dynamicTitle";
function InveestorRelation() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const { slug } = useParams();
  TabTitle(`GMBF | ${slug}`);
  const [investor, setInvestor] = React.useState();
  const APIURL = `${process.env.REACT_APP_URL}reports/all/`;
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(`${APIURL}${slug}`);
        setInvestor(response.data.items);
        // console.log("investor-relation", response.data.items);
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    })();
  }, [slug]);
  const mainData = useMemo(() => {
    if (!investor) return null;
    return nep ? investor.np : investor.en;
  }, [investor, nep]);

  const pageTitle = useMemo(() => {
    switch (slug) {
      case "annual-report":
        return nep ? "वार्षिक प्रतिवेदन" : "Annual Report";
      case "agm-minute":
        return nep ? "एजीएम माएनुट" : "AGM Minute";
      case "key-indicators":
        return nep ? "महत्वपूर्ण संकेतक" : "Key Indicators";
      case "unaudited-financial-highlights":
        return nep
          ? "अडिट नगरेको वित्तीय हाइलाइट"
          : "Unaudited Financial Highlights";
      case "audited-financial-highlights":
        return nep
          ? "अडिट गरिएका वित्तीय हाइलाइट"
          : "Audited Financial Highlights";
      case "basel-report":
        return nep ? "बासेल रिपोर्ट" : "Basel Report";
      case "sebon-quarterly-report":
        return nep ? "सेबोन त्रैमासिक रिपोर्ट" : "SEBON Quarterly Report";
      case "sebon-yearly-report":
        return nep ? "सेबोन वार्षिक रिपोर्ट" : "SEBON Yearly Report";
      case "right-to-information":
        return nep ? "सूचना पाउने अधिकार" : "Right to Information";
      case "subsidized-loan":
        return nep ? "सहायता ऋण" : "Subsidized Loan";
      case "unclaimed-dividend":
        return nep ? "अदावी लाभांश" : "Unclaimed Dividend";
      default:
        return slug;
    }
  }, [slug, nep]);

  if (loading) return <Loading />;
  if (error) return <Errors />;
  const thead = [nep ? "शीर्षक" : "Title", nep ? "फाइल" : "File"];
  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      {mainData.length == "0" ? (
        "Data Not Found"
      ) : (
        <main className="InsidePageContainer">
          <div className="wrapper">
            <table className="InvestorTable">
              <thead>
                <tr>
                  <TableHead thead={thead} />
                </tr>
              </thead>
              <tbody>
                {mainData.map((investor, index) => {
                  delete investor.created;
                  delete investor.category_id;
                  return (
                    <tr key={index}>
                      <TableBody tbody={Object.values(investor)} />
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </main>
      )}

    </>
  );
}

export default InveestorRelation;